import * as React from "react"
import { Form, Tooltip, Flex } from "antd"
import { Select, TextInput, Switch, DebouncePaginatedSelect } from "components-design-system"
import "./AssigneeWorkflowFields.scss"
import { useParams } from "react-router-dom"

// utils
import useWorkflowTeam from "components/WorkflowModalForm/utils/useWorkflowTeam"
import { emailsValidator } from "utilities/antFormUtils"

//api
import { useGetActivity } from "api/hooks/activities/useActivitiesApi"
import { useGetRequestDocuments } from "api/hooks/requests/requestsDocumentsApis"
import { useGetStudyDocuments } from "api/hooks/studies/useDocumentsApi"
import {
  useDocumentSelectOptions,
  filterAllDocuments,
  paginageGetNextDocuments,
} from "api/hooks/documents/useDocumentsApi"

const AssigneeWorkflowFields = ({
  isEmail, // "Assignee" vs "To" (required)
  hasEmailText = true, // include email text field
}) => {
  const { teamOptions } = useWorkflowTeam()

  // document attachments
  const { studyId, activityId, requestId } = useParams()
  const model = !!activityId ? "activity" : "request"
  const { data: activity } = useGetActivity(studyId, activityId)
  const { data: requestFiles } = useGetRequestDocuments(requestId, {
    enabled: !!requestId,
  })
  const { data: studyFiles } = useGetStudyDocuments(activity?.authoring_study_pk, {
    enabled: model === "activity",
  })
  const [allFilesTrue, setAllFilesTrue] = React.useState(false)

  return (
    <>
      <div className="workflow-card activity-assignee-fields">
        <Form.Item
          label={isEmail ? "To" : "Assignees"}
          name="assign_to_ids"
          rules={[
            {
              required: !!isEmail,
            },
          ]}
        >
          <Select
            mode="multiple"
            options={teamOptions}
            allowClear
          />
        </Form.Item>

        {isEmail && (
          <>
            <Form.Item
              label="CC"
              name="cc_emails"
              rules={[emailsValidator]}
            >
              <Select
                mode="tags"
                options={[]}
                allowClear
              />
            </Form.Item>

            {hasEmailText && (
              <Form.Item
                name="additional_email_text"
                label={
                  <Tooltip title="Email templates have been configured by your Prime administrators. You can use this field for additional text. This text will be displayed on the email.">
                    <span className="info-tooltip-text">
                      Email text <i className="fal fa-info-circle" />
                    </span>
                  </Tooltip>
                }
              >
                <TextInput
                  type="textarea"
                  allowClear
                  autoSize={{ minRows: 3, maxRows: 4 }}
                />
              </Form.Item>
            )}
          </>
        )}
      </div>
      {isEmail && (
        <div className="workflow-card activity-assignee-fields">
          <Form.Item
            name={"attachment_docs"}
            label={
              <Flex
                justify="center"
                align="center"
                gap={16}
                className="all-doc-labels-style"
              >
                <Tooltip title="Files relating to the study or request can be added to emails as attachments. Click the dropdown to see what associated files can be attached to the email sent by Prime.">
                  <span className="info-tooltip-text">
                    Email attachments <i className="fal fa-info-circle" />
                  </span>
                </Tooltip>
                <Switch
                  value={allFilesTrue}
                  onChange={() => setAllFilesTrue((prev) => !prev)}
                  label={"All Files"}
                />
              </Flex>
            }
          >
            {allFilesTrue ? (
              <DebouncePaginatedSelect
                useGetInitialData={useDocumentSelectOptions}
                labelInValue={true}
                mode={"multiple"}
                filterAllDocumentsAPI={filterAllDocuments}
                getNextDocumentsAPI={paginageGetNextDocuments}
              />
            ) : (
              <Select
                mode="multiple"
                options={requestId ? requestFiles : studyFiles}
                labelInValue={true}
              />
            )}
          </Form.Item>
        </div>
      )}
    </>
  )
}

export default AssigneeWorkflowFields
